import { get, IHttpRequestConfig, post } from "@/browser";
import { extractDataFromResponse } from "@/core/api";
import { compose, IURLSearchParams } from "@/core/url";

import { ICreateRoleDto, IPartialPageableRole, IRole, pageableRoleType, roleType } from "./types";

const API = {
  list: "/api/skill-roles",
  create: "/api/skill-roles",
};

export interface IFetchRolesListParams extends IURLSearchParams {
  query: string;
}

export const fetchRolesList = (params?: IFetchRolesListParams, options?: IHttpRequestConfig) => {
  const url = compose(API.list, {}, params);
  return get<IPartialPageableRole>(url, options).then(extractDataFromResponse).then(pageableRoleType);
};

export interface IPostRoleParams {}

export const postRole = (params: IPostRoleParams, data: ICreateRoleDto, options?: IHttpRequestConfig) => {
  const url = compose(API.create, {}, params);

  return post<IRole>(url, data, options).then(extractDataFromResponse).then(roleType);
};
